import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { PageHero } from '../../components/PageHero';
import { Link } from 'react-router-dom';
export function PrivateDiningPage() {
  return <div className="bg-brand-beige" data-id="element-654">
      <PageHero title="Private Dining & Events" subtitle="Elegant spaces and bespoke menus for your most memorable celebrations." backgroundImage="https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=1920&q=80" data-id="element-655" />

      <section className="py-24 md:py-32 relative overflow-hidden" data-id="element-656">
        <div className="absolute inset-0 bg-noise opacity-30 pointer-events-none" data-id="element-657"></div>

        <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-658">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-32" data-id="element-659">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-660">
              <h2 className="text-4xl md:text-5xl font-serif text-brand-dark mb-6" data-id="element-661">
                Lamirage Events
              </h2>
              <div className="w-16 h-1 bg-brand-terracotta mb-8" data-id="element-662"></div>
              <p className="text-lg text-brand-dark/80 font-light leading-relaxed mb-8" data-id="element-663">
                Whether you are hosting an intimate anniversary dinner, a
                corporate board meeting, or a grand wedding reception, our
                dedicated events team ensures every detail is executed
                flawlessly.
              </p>
              <p className="text-lg text-brand-dark/80 font-light leading-relaxed mb-10" data-id="element-664">
                We offer exclusive buyouts of our flagship restaurants, as well
                as dedicated private dining rooms equipped with state-of-the-art
                AV capabilities and dedicated service staff.
              </p>
              <Link to="/company/contact" className="inline-block bg-brand-dark text-white px-8 py-4 text-sm uppercase tracking-[0.2em] hover:bg-brand-red transition-colors" data-id="element-665">
                View Lamirage Website
              </Link>
            </motion.div>

            <motion.div className="grid grid-cols-2 gap-4" initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} data-id="element-666">
              <img src="https://images.unsplash.com/photo-1519167758481-83f550bb49b3?w=600&q=80" alt="Event setup" className="w-full h-64 object-cover rounded-sm" data-id="element-667" />
              <img src="https://images.unsplash.com/photo-1466978913421-bac2e5e42729?w=600&q=80" alt="Plated food" className="w-full h-64 object-cover rounded-sm mt-8" data-id="element-668" />
            </motion.div>
          </div>

          {/* Inquiry Form */}
          <motion.div className="bg-white p-10 md:p-16 rounded-sm shadow-2xl max-w-4xl mx-auto" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-669">
            <div className="text-center mb-12" data-id="element-670">
              <h3 className="text-3xl font-serif text-brand-dark mb-4" data-id="element-671">
                Plan Your Event
              </h3>
              <p className="text-brand-dark/60 font-light" data-id="element-672">
                Fill out the form below and our events team will be in touch
                shortly.
              </p>
            </div>

            <form className="space-y-8" onSubmit={e => e.preventDefault()} data-id="element-673">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-674">
                <div data-id="element-675">
                  <label className="block text-xs uppercase tracking-widest text-brand-dark/70 mb-2" data-id="element-676">
                    First Name
                  </label>
                  <input type="text" className="w-full border-b border-brand-dark/20 py-2 focus:outline-none focus:border-brand-gold transition-colors" data-id="element-677" />
                </div>
                <div data-id="element-678">
                  <label className="block text-xs uppercase tracking-widest text-brand-dark/70 mb-2" data-id="element-679">
                    Last Name
                  </label>
                  <input type="text" className="w-full border-b border-brand-dark/20 py-2 focus:outline-none focus:border-brand-gold transition-colors" data-id="element-680" />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-681">
                <div data-id="element-682">
                  <label className="block text-xs uppercase tracking-widest text-brand-dark/70 mb-2" data-id="element-683">
                    Email Address
                  </label>
                  <input type="email" className="w-full border-b border-brand-dark/20 py-2 focus:outline-none focus:border-brand-gold transition-colors" data-id="element-684" />
                </div>
                <div data-id="element-685">
                  <label className="block text-xs uppercase tracking-widest text-brand-dark/70 mb-2" data-id="element-686">
                    Phone Number
                  </label>
                  <input type="tel" className="w-full border-b border-brand-dark/20 py-2 focus:outline-none focus:border-brand-gold transition-colors" data-id="element-687" />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-688">
                <div data-id="element-689">
                  <label className="block text-xs uppercase tracking-widest text-brand-dark/70 mb-2" data-id="element-690">
                    Event Date
                  </label>
                  <input type="date" className="w-full border-b border-brand-dark/20 py-2 focus:outline-none focus:border-brand-gold transition-colors text-brand-dark" data-id="element-691" />
                </div>
                <div data-id="element-692">
                  <label className="block text-xs uppercase tracking-widest text-brand-dark/70 mb-2" data-id="element-693">
                    Guest Count
                  </label>
                  <input type="number" className="w-full border-b border-brand-dark/20 py-2 focus:outline-none focus:border-brand-gold transition-colors" data-id="element-694" />
                </div>
                <div data-id="element-695">
                  <label className="block text-xs uppercase tracking-widest text-brand-dark/70 mb-2" data-id="element-696">
                    Event Type
                  </label>
                  <select className="w-full border-b border-brand-dark/20 py-2 focus:outline-none focus:border-brand-gold transition-colors text-brand-dark bg-transparent" data-id="element-697">
                    <option data-id="element-698">Corporate</option>
                    <option data-id="element-699">Wedding</option>
                    <option data-id="element-700">Social/Party</option>
                    <option data-id="element-701">Other</option>
                  </select>
                </div>
              </div>
              <div data-id="element-702">
                <label className="block text-xs uppercase tracking-widest text-brand-dark/70 mb-2" data-id="element-703">
                  Additional Details
                </label>
                <textarea rows={4} className="w-full border-b border-brand-dark/20 py-2 focus:outline-none focus:border-brand-gold transition-colors resize-none" data-id="element-704"></textarea>
              </div>
              <button className="w-full bg-brand-dark text-white py-4 text-sm uppercase tracking-[0.2em] font-medium hover:bg-brand-red transition-colors mt-4" data-id="element-705">
                Submit Inquiry
              </button>
            </form>
          </motion.div>
        </div>
      </section>
    </div>;
}